<template>
  <div class="inputfield">
    <div>{{label}}</div>
    <slot/>
  </div>
</template>

<script>
export default {
  props: ['label']
}
</script>
<style lang="scss" scoped>
.inputfield {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &>div:nth-child(1) {
    margin-right: 10px;
    width: 4.2em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px;
    color: var(--color-letter);
    min-width: 4.2em;
  }
  input[type=text] {
    width: 250px;
    height: 35px;
    border-radius: 3px;
    border: 1px solid var(--color-border);
    font-size: 16px;
  }
  input[type=checkbox] {
    width: 25px;
    height: 25px;
  }
}
</style>
